module.exports = __webpack_public_path__ + "img/GR084.eed0c7cf.png";